(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["age-gate"] && !Shopify.designMode) return;
  try {
    function setCookie(name, value, expiry) {
    const date = new Date();
    date.setTime(date.getTime() + expiry * 24 * 60 * 60 * 1000);

    const expiration = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expiration};path=/`;
  }

  function getCookie(name) {
    const cookieName = `${name}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }

    return '';
  }

  const dialog = document.querySelector('#age-gate');
  const buttonNo = document.querySelector('#age-button-no');
  const buttonYes = document.querySelector('#age-button-yes');
  const error = document.querySelector('#age-gate-error');
  const form = document.forms['age-gate'];

  if (buttonNo && error) {
    buttonNo.addEventListener('click', function () {
      error.style.display = 'block';
    });
  }

  if (buttonYes && form) {
    buttonYes.addEventListener('click', function (e) {
      const data = new FormData(form);

      if (data) {
        const cookie = data.get('remember');

        if (cookie) {
          setCookie('stambecco_age', true, 30);
        }
      }
    });
  }

  const cookie = getCookie('stambecco_age');

  if (dialog && !cookie && !Shopify.designMode) {
    dialog.showModal();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nav"] && !Shopify.designMode) return;
  try {
    const dialog = document.querySelector('#nav-menu');

  const open = document.querySelector('#nav-menu-open-button');
  open.addEventListener('click', function () {
    dialog.showModal();
  });

  const close = document.querySelector('#nav-menu-close-button');
  close.addEventListener('click', function (e) {
    dialog.close();
  });

  const links = document.querySelectorAll('.nav__menu-listitem__link');
  links.forEach((link) => {
    link.addEventListener('click', function () {
      dialog.close();
    });
  });

  const mediaQuery = `(min-width: 48rem)`;
  const mediaQueryList = globalThis.matchMedia(mediaQuery);
  mediaQueryList.addEventListener('change', function (e) {
    if (e.matches && dialog.open) {
      dialog.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
